module.exports = __webpack_public_path__ + "static/media/align.ee9dd8b7.svg";